/** Spinner shown while a page's initial fetch is in flight. */
export function LoadingState({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="d-flex align-items-center justify-content-center py-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">{label}</span>
      </div>
    </div>
  );
}

/** Full-width error callout, used where the Razor pages would simply have rendered empty. */
export function ErrorState({ message }: { message: string }) {
  return (
    <div className="alert alert-danger d-flex align-items-center gap-2" role="alert">
      <i className="bi bi-exclamation-triangle-fill flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
}
